/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Recent log entry
 * @export
 * @interface WebApiAdminDtoRecentLogDto
 */
export interface WebApiAdminDtoRecentLogDto {
    /**
     * Log entry ID
     * @type {number}
     * @memberof WebApiAdminDtoRecentLogDto
     */
    id?: number;
    /**
     * When the log was created
     * @type {Date}
     * @memberof WebApiAdminDtoRecentLogDto
     */
    createdAt?: Date;
    /**
     * Log level (Error, Warning, etc.)
     * @type {string}
     * @memberof WebApiAdminDtoRecentLogDto
     */
    level?: string | null;
    /**
     * Log message
     * @type {string}
     * @memberof WebApiAdminDtoRecentLogDto
     */
    message?: string | null;
    /**
     * Logger name
     * @type {string}
     * @memberof WebApiAdminDtoRecentLogDto
     */
    logger?: string | null;
    /**
     * Exception details if any
     * @type {string}
     * @memberof WebApiAdminDtoRecentLogDto
     */
    exception?: string | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoRecentLogDto interface.
 */
export function instanceOfWebApiAdminDtoRecentLogDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoRecentLogDtoFromJSON(json: any): WebApiAdminDtoRecentLogDto {
    return WebApiAdminDtoRecentLogDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoRecentLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoRecentLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'level': !exists(json, 'level') ? undefined : json['level'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'logger': !exists(json, 'logger') ? undefined : json['logger'],
        'exception': !exists(json, 'exception') ? undefined : json['exception'],
    };
}

export function WebApiAdminDtoRecentLogDtoToJSON(value?: WebApiAdminDtoRecentLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'level': value.level,
        'message': value.message,
        'logger': value.logger,
        'exception': value.exception,
    };
}

